import { ModelMixin, Model } from '../../../domain/model/common/model.class';

export class Document {
    type: string;
    id: string;
    description: string;
    date?: string;
    dateTime?: string;
    url: string;
    specialty?: string;
    completed?: boolean;
    fromDate?: string;
    toDate?: string;
    certificationDate?: string;
    recertificationDate?: string;
    expirationDate?: string;
    state?: string;
    checked: boolean = false;
    readableDetails?: string;
}

export class Section {
    name: string;
    documents?: Document[];
    sections?: Section[];
    checked: boolean = false;
    indeterminate: boolean = false;
}

export class DocumentsModel extends ModelMixin() implements Model<DocumentsModel> {
    TYPE = DocumentsModel;
    sections: Section[];

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}

export class DownloadableFile {
    fileName: string;
    id: string;
    requestDate: string;
    status: string;
    version: number;
}

export class DownloadableFiles extends ModelMixin() implements Model<DownloadableFiles> {
    TYPE = DownloadableFiles;
    results: Array<DownloadableFile>;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}

// Emulates a string enum, which is supported in TypeScript 2.4+
export class DocumentType {
    static NONE = 'None';
    static DL = 'Driver\'s License';
    static DOC = 'Document';
    static CME = 'CME';
    static LE = 'Licensing Examinations';
    static DEA = 'DEA';
    static LC = 'Life Certifications';
    static PL = 'Professional Licenses';
    static AOA = 'AOA';
    static AOAS = 'AOA Subspecialty';
    static CSP = 'Control Substance Permit';
    static ABPS = 'ABPS';
    static ABMSS = 'ABMS Subspecialty';
    static ABMS = 'ABMS';
    static MD = 'Military Discharge';
    static AL = 'Activity Log';
    static OE = 'Other Education';
    static I = 'Internship';
    static R = 'Residency';
    static F = 'Fellowship';
    static ECFMG = 'ECFMG';
    static M = 'Medical';
    static P = 'Premedical';
    static PL_ICTC = 'Infectious Control Training Course';
    static PL_CAC = 'Child Abuse Clearance';
    static PL_BC = 'Background Clearance';
    static AMA = 'AMA Report';
    static BG = 'Background Report';
    static LS = 'License Sanctions Report';
    static MMS = 'Medicare/Medicaid Sanction Report';
    static NPDB = 'NPDB Report';
    static OIG = 'OIG Report';
    static SAM = 'SAM Report';
    constructor(public value: string) {}
    toString() { return this.value; }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/documents/model/documents.model.ts